<!--
 * @Date         : 2021-04-02 17:50:32
 * @LastEditors: zhangxu
 * @LastEditTime: 2022-05-13 20:21:08
 * @FilePath: /daodao-biz-front/src/components/Loading/src/index.vue
-->
<template>
  <section class="full-loading" :class="{ absolute }" v-show="loading" :style="getStyle" @click.stop="() => {}">
    <Spin v-bind="$attrs" :size="size" :spinning="loading" />
    <div class="tip">{{ tip || '数据加载中' }}</div>
  </section>
</template>
<script lang="ts">
import { computed, CSSProperties, defineComponent, PropType } from 'vue'
import { Spin } from 'ant-design-vue'

import { SizeEnum } from '@/enums/sizeEnum'

export default defineComponent({
  name: 'Loading',
  components: { Spin },
  props: {
    tip: {
      type: String as PropType<string>,
      default: '',
    },
    size: {
      type: String as PropType<SizeEnum>,
      default: SizeEnum.LARGE,
      validator: (v: SizeEnum): boolean => {
        return [SizeEnum.DEFAULT, SizeEnum.SMALL, SizeEnum.LARGE].includes(v)
      },
    },
    absolute: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    loading: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    background: {
      type: String as PropType<string>,
    },
  },
  setup(props) {
    const getStyle = computed((): CSSProperties => {
      const { background } = props
      const bgColor = background || 'rgba(240, 242, 245, 0.3)'
      return { background: bgColor }
    })

    return { getStyle }
  },
})
</script>
<style lang="scss" scoped>
.full-loading {
  position: fixed;
  top: 56px;
  left: 80px;
  z-index: 1200;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &.absolute {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
  }
}
.tip {
  margin-left: 10px;
  color: #44b979;
  font-size: 20px;
}
</style>
